import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  canlenderFilter,
  filters,
  searchBy,
} from "../../../service/subcategoryService.js";
import { useFetchAll } from "../../../custom/FetchApiHook.jsx";
import { SubCategoryApi } from "../../../App/api/menu.apis.js";
import AddSubCategory from "./AddSubCategory.jsx";
import OrderFilters from "../../../Components/Common/Filters/OrderFilters.jsx";
import PaginatorCom from "../../../Components/Paginator/PaginatorCom.jsx";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import moment from "moment";
import { FaRegEdit } from "react-icons/fa";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import placeHolderImage from "../../../Assets/images/image-not-available.jpg";
import styles from "./subcategory.module.css";

const SubCategoryComp = ({
  disabledFilters,
  pagination,
  handlePagination,
  accessSubCategory,
}) => {
  const [search, setSearch] = useState("");
  const [gridToggle, setGridToggle] = useState(false);
  const debounceTimeout = useRef(null);
  const { value, fetchAllData } = useFetchAll(() =>
    SubCategoryApi.getSubCategory(pagination, search)
  );
  const [addSubcategory, setAddSubcategory] = useState(false);
  const [editSubcategory, setEditSubcategory] = useState(null);

  const closeSubCategoryModal = () => {
    setAddSubcategory(false);
    setEditSubcategory(null);
  };

  const handleEditSubcategory = (item) => {
    if (!accessSubCategory?.update) return;
    setEditSubcategory(item);
    setAddSubcategory(true);
  };

  const onPaginatorClick = (e) => {
    if (e) {
      const data = {
        limit: e.rows,
        page: +e.page + 1,
      };
      handlePagination && handlePagination(data);
    }
  };

  const handleSearch = useCallback((s) => {
    setSearch(s);
  }, []);

  const debouncedSearch = useCallback(
    (s) => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
      debounceTimeout.current = setTimeout(() => {
        handleSearch(s);
      }, 1500);
    },
    [handleSearch]
  );

  const handleClearFilter = () => {
    const clearPagination = {
      page: 1,
      limit: 5,
      sortOrder: "desc",
      filter: {},
    };
    handlePagination && handlePagination({ clearPagination });
    setSearch("");
  };

  const handleFilter = (name, value) => {
    let data = {};
    if (name === "search_by") {
      data.sortOrder = value.code;
    } else {
      const filter = {};
      filter[name] = value.code ? value.code : value;
      data.filter = filter;
    }

    handlePagination && handlePagination(data);
  };

  useEffect(() => {
    fetchAllData();
  }, [pagination, search]);

  const DataFilter = filters.filter((f) =>
    disabledFilters ? !disabledFilters.includes(f.inputName) : true
  );

  const subcategories = value?.data?.subcategories || [];

  return (
    <div className="p-5">
      <div className={styles.card}>
        <OrderFilters
          layoutView={true}
          gridToggle={gridToggle}
          SetGridToggle={setGridToggle}
          filters={DataFilter}
          SearchBy={searchBy}
          handleSearch={debouncedSearch}
          handleFilter={(name, filterValue) => handleFilter(name, filterValue)}
          handleClearFilter={handleClearFilter}
          WeekRange={false}
          MonthRange={true}
          canlenderFilter={canlenderFilter}
          actionButton={
            accessSubCategory.read
              ? {
                  button_name: "Add",
                  handleButton: () => setAddSubcategory(true),
                }
              : null
          }
        />

        {gridToggle ? (
          <div className={styles.gridContainer}>
            {subcategories.length > 0 ? (
              subcategories.map((item) => (
                <div
                  key={item._id}
                  className={styles.gridCard}
                  onClick={() => handleEditSubcategory(item)}
                >
                  <div className={styles.imageWrap}>
                    {item?.image ? (
                      <LazyLoadImage
                        src={item.image}
                        effect="blur"
                        wrapperProps={{
                          style: { transitionDelay: ".5s" },
                        }}
                        className={styles.cardImage}
                      />
                    ) : (
                      <img
                        src={placeHolderImage}
                        alt={item.name}
                        className={styles.cardImage}
                      />
                    )}
                    {accessSubCategory?.update && (
                      <button
                        type="button"
                        className={styles.editButton}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleEditSubcategory(item);
                        }}
                        aria-label={`Edit ${item.name}`}
                      >
                        <FaRegEdit />
                      </button>
                    )}
                  </div>
                  <div className={styles.cardBody}>
                    <p className={styles.cardTitle}>{item?.name || ""}</p>
                    <p className={styles.cardMeta}>
                      Category: {item?.Category?.name || "N/A"}
                    </p>
                    <div className={styles.cardFooter}>
                      <span className={styles.cardDate}>
                        {moment(item?.createdAt).utc().format("DD MMM YYYY")}
                      </span>
                      <span
                        className={`${styles.statusBadge} ${
                          item?.status === "Approved"
                            ? styles.statusApproved
                            : styles.statusPending
                        }`}
                      >
                        {item?.status || "N/A"}
                      </span>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className={styles.emptyState}>No subcategory found.</div>
            )}
          </div>
        ) : (
          <div className={styles.tableWrapper}>
            <DataTable
              value={subcategories}
              dataKey="_id"
              emptyMessage="No subcategory found."
            >
              <Column
                header="Image"
                body={(rowData) => (
                  <div className={styles.cellClickable}>
                    {rowData?.image ? (
                      <LazyLoadImage
                        src={rowData.image}
                        alt={rowData?.name || "Subcategory"}
                        effect="blur"
                        wrapperProps={{
                          style: { transitionDelay: ".5s" },
                        }}
                        className={styles.tableThumbnail}
                      />
                    ) : (
                      <img
                        src={placeHolderImage}
                        alt={rowData?.name || "Subcategory"}
                        className={styles.tableThumbnail}
                      />
                    )}
                  </div>
                )}
              />
              <Column
                header="Date"
                body={(rowData) => (
                  <div className={styles.cellClickable}>
                    {moment(rowData?.createdAt).utc().format(
                      "DD MMM YYYY hh:mma"
                    )}
                  </div>
                )}
              />
              <Column
                header="Category"
                body={(rowData) => (
                  <div className={styles.cellClickable}>
                    {rowData?.Category?.name || ""}
                  </div>
                )}
              />
              <Column
                header="Subcategory"
                body={(rowData) => (
                  <div className={styles.cellClickable}>{rowData?.name || ""}</div>
                )}
              />
              <Column
                header="Status"
                body={(rowData) => (
                  <div className={styles.cellClickable}>
                    {rowData?.status || ""}
                  </div>
                )}
              />
              <Column
                header="Actions"
                body={(rowData) => (
                  <div className={styles.tableActions}>
                    {accessSubCategory?.update && (
                      <button
                        type="button"
                        className={styles.tableActionButton}
                        onClick={() => handleEditSubcategory(rowData)}
                        aria-label={`Edit ${rowData.name}`}
                      >
                        <FaRegEdit />
                      </button>
                    )}
                  </div>
                )}
              />
            </DataTable>
          </div>
        )}

        <PaginatorCom
          paginatorData={{
            filters: null,
            first: 0,
            multiSortMeta: [],
            page: value?.data?.page || 1,
            rows: value?.data?.limit || 5,
            sortField: null,
            sortOrder: null,
            totalPages: value?.data?.totalPages || 1,
            totalCount: value?.data?.totalCount || 1,
          }}
          onPaginatorClick={onPaginatorClick}
        />
      </div>

      <AddSubCategory
        getAllData={fetchAllData}
        currentItems={editSubcategory}
        open={addSubcategory}
        handleClose={() => closeSubCategoryModal()}
      />
    </div>
  );
};

export default SubCategoryComp;
